 import { Link } from "react-router"

 export default function RestCard({restInfo}){


    return(
        <Link to={"/city/delhi/"+restInfo?.info?.id}>
        <div className="mx-w-[280px] mt-2 transform transition duration-200 hover:scale-95">
        <img className="w-70 h-45 object-cover rounded-xl" src={"https://media-assets.swiggy.com/swiggy/image/upload/"+ restInfo?.info?.cloudinaryImageId}></img>
        <div className="w-[95%] mx-auto mt-3">
        <div className="font-bold text-xl">{restInfo?.info?.name}</div>
        <div className="flex gap-2">
        <span className="text-lg">{restInfo?.info?.avgRating}</span>
        <span className="text-lg font-semibold">{restInfo?.info?.sla?.slaString}</span>
        </div>
        <div className="text-gray-600 text-xl mt-1 h-7 overflow-hidden">{restInfo?.info?.cuisines.join("")}</div>
        </div>
        </div>
        </Link>
    )
}